export default __webpack_public_path__ + "static/bgpicaro-17da06dd7c690e7635d17a7bcf690285.webm";